export const societePolitique: string[] = [
  "Est-ce que la peine de mort est justifiable dans certains cas ?",
  "Est-ce qu'on devrait légaliser toutes les drogues ?",
  "Est-ce que les riches devraient payer 80% d'impôts ?",
  "Est-ce que l'immigration devrait être totalement libre ?",
  "Est-ce que le vote devrait être obligatoire ?",
  "Est-ce que les réseaux sociaux font plus de mal que de bien à la société ?",
  "Est-ce qu'on devrait interdire la viande ?",
  "Est-ce que les prisons devraient être supprimées ?",
  "Est-ce que les politiciens devraient avoir un salaire de SMIC ?",
  "Est-ce que l'école devrait être payante pour responsabiliser les élèves ?",
  "Est-ce que le mariage devrait avoir une durée limitée de 5 ans renouvelable ?",
  "Est-ce que les réseaux sociaux devraient être interdits aux moins de 18 ans ?",
  "Est-ce que la prostitution devrait être totalement légalisée et encadrée ?",
  "Est-ce qu'on devrait interdire les voitures en ville ?",
  "Est-ce que les parents devraient être jugés pour les crimes de leurs enfants mineurs ?",
  "Est-ce que l'argent liquide devrait être supprimé ?",
  "Est-ce que les réseaux sociaux devraient être responsables des contenus publiés sur leurs plateformes ?",
  "Est-ce qu'on devrait interdire les fast-foods pour lutter contre l'obésité ?",
  "Est-ce que le travail du sexe devrait être considéré comme un métier normal ?",
  "Est-ce qu'on devrait tester les politiciens psychologiquement avant de les élire ?",
  "Est-ce que les religions ont plus divisé l'humanité qu'elles ne l'ont unie ?",
  "Est-ce qu'on devrait limiter le nombre d'enfants par famille comme en Chine ?",
  "Est-ce qu'on devrait interdire les publicités ciblant les enfants ?",
  "Est-ce qu'on devrait pouvoir déchoir de sa nationalité quelqu'un qui commet un crime grave ?",
  "Est-ce que l'éducation sexuelle devrait commencer dès le primaire ?",
  "Est-ce qu'on devrait interdire les jeux vidéo violents aux mineurs ?",
  "Est-ce que le service militaire devrait être obligatoire pour tous ?",
  "Est-ce qu'on devrait taxer davantage les produits polluants même si ça pénalise les pauvres ?",
  "Est-ce que les prisons devraient se concentrer sur la réinsertion plutôt que la punition ?",
  "Est-ce qu'on devrait interdire les cryptomonnaies pour leur impact environnemental ?",
  "Est-ce que les influenceurs devraient payer plus d'impôts que les salariés classiques ?",
  "Est-ce qu'on devrait supprimer les notes à l'école ?",
  "Est-ce que l'euthanasie devrait être légale pour tout le monde qui le demande ?",
  "Est-ce qu'on devrait interdire les armes à feu même pour la chasse ?",
  "Est-ce que les enfants de criminels devraient être surveillés par l'État ?",
  "Est-ce qu'on devrait interdire les religions dans les espaces publics ?",
  "Est-ce qu'on devrait tester le QI des candidats à la présidentielle ?",
  "Est-ce que les médias mentent plus qu'ils n'informent ?",
  "Est-ce qu'on devrait interdire les smartphones dans les écoles primaires et secondaires ?",
  "Est-ce que les stars du foot gagnent indécemment trop d'argent ?",
  "Est-ce qu'on devrait rembourser la chirurgie esthétique par la sécurité sociale ?",
  "Est-ce qu'on devrait interdire la publicité pour l'alcool et les cigarettes complètement ?",
];

export const moralEthique: string[] = [
  "Est-ce qu'il est acceptable de mentir pour protéger quelqu'un qu'on aime ?",
  "Est-ce qu'on a le droit de tromper quelqu'un qui nous a déjà trompé ?",
  "Est-ce qu'on devrait dire la vérité même si elle fait mal ?",
  "Est-ce que la fin justifie les moyens ?",
  "Est-ce qu'on est responsable du bonheur des autres ?",
  "Est-ce qu'il est acceptable de lire les messages de son/sa partenaire par jalousie ?",
  "Est-ce qu'on a le droit de juger les gens sur leur apparence ?",
  "Est-ce qu'il est acceptable de voler pour nourrir sa famille ?",
  "Est-ce qu'on devrait pardonner quelqu'un qui ne regrette pas ?",
  "Est-ce que la loyauté envers un ami prime sur la justice ?",
  "Est-ce qu'il est acceptable de trahir un secret pour protéger quelqu'un ?",
  "Est-ce que le silence est une forme de mensonge ?",
  "Est-ce qu'on est responsable de ce qu'on fait quand on est ivre ?",
  "Est-ce qu'on devrait sacrifier une personne pour en sauver dix ?",
  "Est-ce que la jalousie est une preuve d'amour ou un défaut ?",
  "Est-ce qu'il est acceptable de détester quelqu'un sans raison apparente ?",
  "Est-ce qu'il est acceptable de couper les liens avec sa famille si elle est toxique ?",
  "Est-ce qu'on devrait aider financièrement un ami dans le besoin même si on sait qu'il va gaspiller ?",
  "Est-ce qu'on a le droit de haïr quelqu'un qui ne nous a rien fait personnellement ?",
  "Est-ce qu'il est acceptable de mentir sur son CV pour décrocher un emploi qu'on mérite ?",
  "Est-ce qu'on devrait toujours respecter les lois même quand elles sont injustes ?",
  "Est-ce qu'il est moral de gagner un débat en utilisant des arguments qu'on ne croit pas vraiment ?",
  "Est-ce qu'on a une responsabilité envers les générations futures ?",
  "Est-ce qu'il est acceptable de se faire justice soi-même quand le système judiciaire échoue ?",
  "Est-ce qu'on devrait juger une personne sur ses actes passés même si elle a changé ?",
  "Est-ce qu'on devrait toujours dire la vérité à un mourant même si elle est cruelle ?",
  "Est-ce qu'on a le droit de refuser d'aider quelqu'un qui n'a pas voulu s'aider lui-même ?",
  "Est-ce qu'on devrait punir davantage les crimes commis par des gens éduqués ?",
  "Est-ce qu'il est acceptable de faire du mal à quelqu'un pour son bien ?",
  "Est-ce qu'on a le droit de profiter du bonheur quand les autres souffrent ?",
  "Est-ce qu'il est moral de créer un enfant dans un monde aussi incertain ?",
  "Est-ce qu'on a le droit de ne pas pardonner même après des années ?",
  "Est-ce qu'on devrait toujours avouer une erreur même si personne ne la découvrira jamais ?",
  "Est-ce qu'il est moral de laisser quelqu'un croire un mensonge qui le rend heureux ?",
  "Est-ce qu'on a une obligation morale d'être généreux quand on est riche ?",
  "Est-ce qu'on a le droit d'être égoïste pour se protéger mentalement ?",
  "Est-ce qu'il est acceptable de sacrifier son bonheur pour celui de ses enfants ?",
  "Est-ce qu'on devrait toujours s'excuser même quand on ne le pense pas vraiment ?",
  "Est-ce qu'il est moral de vivre dans le luxe quand d'autres meurent de faim ?",
];

export const relationnelPerso: string[] = [
  "Est-ce que l'infidélité émotionnelle est pire que l'infidélité physique ?",
  "Est-ce qu'on peut vraiment rester ami avec un ex ?",
  "Est-ce que l'amour suffit pour faire durer une relation ?",
  "Est-ce qu'on devrait tout dire à son/sa partenaire ?",
  "Est-ce que la distance peut tuer une relation même solide ?",
  "Est-ce qu'il est possible d'aimer deux personnes en même temps ?",
  "Est-ce qu'on choisit vraiment les personnes dont on tombe amoureux ?",
  "Est-ce que le coup de foudre existe vraiment ?",
  "Est-ce qu'une amitié entre un homme et une femme peut être purement platonique ?",
  "Est-ce qu'on peut pardonner une trahison d'un meilleur ami ?",
  "Est-ce que la famille passe toujours avant les amis ?",
  "Est-ce qu'on devrait dire à un ami que son/sa partenaire le/la trompe ?",
  "Est-ce que les opposés s'attirent vraiment ou c'est un mythe ?",
  "Est-ce qu'une relation peut survivre à une infidélité ?",
  "Est-ce que l'amour à distance est voué à l'échec ?",
  "Est-ce qu'on devient forcément comme ses parents dans ses relations ?",
  "Est-ce que les réseaux sociaux ont tué les vraies relations ?",
  "Est-ce qu'on peut être heureux(se) seul(e) toute sa vie ?",
  "Est-ce que les gens changent vraiment dans une relation ?",
  "Est-ce qu'il faut avoir vécu beaucoup de relations pour trouver la bonne ?",
  "Est-ce qu'une relation peut survivre quand l'un des deux a beaucoup plus de succès que l'autre ?",
  "Est-ce qu'on choisit ses amis ou c'est le hasard qui décide vraiment ?",
  "Est-ce qu'une vraie amitié peut exister entre des personnes de milieux très différents ?",
  "Est-ce qu'on devrait dire à un ami que son/sa partenaire n'est pas fait pour lui/elle ?",
  "Est-ce qu'une rupture à l'amiable est possible ou c'est toujours un mensonge ?",
  "Est-ce qu'on peut vraiment oublier quelqu'un qu'on a profondément aimé ?",
  "Est-ce que les gens qu'on fréquente nous définissent vraiment ?",
  "Est-ce qu'une amitié de 20 ans peut se terminer du jour au lendemain pour une bonne raison ?",
  "Est-ce qu'on devrait parler de ses problèmes mentaux à son/sa partenaire dès le début ?",
  "Est-ce qu'il est possible de vraiment connaître quelqu'un ?",
  "Est-ce qu'une relation toxique peut devenir saine avec du travail ?",
  "Est-ce qu'on devrait couper les ponts avec un ami qui fréquente nos ennemis ?",
  "Est-ce que les enfants devraient être au courant des problèmes financiers de leur famille ?",
  "Est-ce qu'on devrait sacrifier sa carrière pour sa relation amoureuse ?",
  "Est-ce qu'il est possible d'être de bons parents après une rupture difficile ?",
  "Est-ce qu'on devrait toujours défendre ses amis même quand ils ont tort ?",
  "Est-ce qu'une amitié sans disputes est une vraie amitié ?",
  "Est-ce que la confiance peut vraiment se reconstruire après une trahison ?",
  "Est-ce qu'on devrait tout partager financièrement dans un couple ?",
  "Est-ce que les relations longue distance renforcent ou détruisent les couples ?",
  "Est-ce qu'on peut vraiment avoir une relation saine sans avoir réglé ses problèmes personnels ?",
  "Est-ce qu'il est possible d'être jaloux(se) sans que ça devienne toxique ?",
  "Est-ce qu'on devrait toujours dire à un ami ce qu'on pense vraiment de son/sa partenaire ?",
  "Est-ce qu'une amitié peut survivre quand l'un devient beaucoup plus riche que l'autre ?",
  "Est-ce qu'on devrait pardonner à quelqu'un de sa famille qui nous a gravement blessé ?",
  "Est-ce qu'il est possible d'être de vrais amis avec ses collègues de travail ?",
  "Est-ce qu'on devrait accepter les défauts de son/sa partenaire ou essayer de les changer ?",
  "Est-ce qu'une relation amoureuse peut survivre sans confiance totale ?",
  "Est-ce qu'il est acceptable de mettre fin à une amitié par message ?",
  "Est-ce qu'on devrait toujours être honnête sur ses sentiments même si ça blesse l'autre ?",
  "Est-ce qu'une famille recomposée peut être aussi unie qu'une famille traditionnelle ?",
  "Est-ce qu'il est possible d'aimer quelqu'un sans le connaître vraiment ?",
  "Est-ce qu'on devrait partager tous ses mots de passe avec son/sa partenaire ?",
  "Est-ce qu'une relation peut durer si les deux personnes ont des valeurs opposées ?",
  "Est-ce qu'on devrait toujours choisir son/sa partenaire plutôt que ses amis ?",
  "Est-ce qu'une relation peut vraiment survivre à une période de dépression profonde ?",
];

export const wtfDecale: string[] = [
  "Est-ce que les extraterrestres existent et nous observent en ce moment ?",
  "Est-ce que la vie est une simulation ?",
  "Est-ce que le destin existe ou on contrôle tout ?",
  "Est-ce qu'on devrait pouvoir choisir le sexe de son enfant ?",
  "Est-ce que les animaux ont des sentiments aussi complexes que les humains ?",
  "Est-ce que l'argent fait le bonheur ou c'est juste un cliché ?",
  "Est-ce qu'on devrait pouvoir choisir le jour de sa mort ?",
  "Est-ce que les fantômes existent ?",
  "Est-ce que le paradis et l'enfer existent ?",
  "Est-ce qu'une intelligence artificielle pourrait tomber amoureuse ?",
  "Est-ce qu'on devrait pouvoir cloner les humains ?",
  "Est-ce que les célébrités ont une influence trop grande sur la société ?",
  "Est-ce qu'on devrait pouvoir voyager dans le temps si c'était possible ?",
  "Est-ce que le bonheur est un choix ou une chance ?",
  "Est-ce que les rêves ont une signification réelle ?",
  "Est-ce qu'on devrait pouvoir modifier génétiquement ses enfants pour les rendre plus intelligents ?",
  "Est-ce que l'humanité va s'autodétruire dans les 100 prochaines années ?",
  "Est-ce que les animaux devraient avoir les mêmes droits que les humains ?",
  "Est-ce qu'on devrait vivre sur Mars si la Terre devenait inhabitable ?",
  "Est-ce que l'humanité est fondamentalement bonne ou mauvaise ?",
  "Est-ce que les animaux ont une vie spirituelle ?",
  "Est-ce qu'une IA pourrait un jour gouverner un pays mieux qu'un humain ?",
  "Est-ce que le libre arbitre existe vraiment ou tout est déterminé à l'avance ?",
  "Est-ce qu'on devrait pouvoir effacer ses souvenirs douloureux si c'était possible ?",
  "Est-ce que les humains sont faits pour vivre en couple ou c'est une construction sociale ?",
  "Est-ce qu'une société sans argent pourrait fonctionner ?",
  "Est-ce que la beauté est une forme de privilège social ?",
  "Est-ce qu'on devrait pouvoir choisir ses propres lois si on vit seul sur une île ?",
  "Est-ce que l'art a encore une valeur dans un monde où l'IA peut tout créer ?",
  "Est-ce que la célébrité est une malédiction ou une bénédiction ?",
  "Est-ce que la nostalgie nous empêche d'avancer ?",
  "Est-ce que les humains ont besoin de croire en quelque chose pour survivre ?",
  "Est-ce que la solitude est un choix ou une fatalité ?",
  "Est-ce qu'une société sans compétition serait meilleure ou pire pour l'humanité ?",
  "Est-ce que la musique peut changer fondamentalement une société ?",
  "Est-ce que l'humour peut être une forme de violence déguisée ?",
];

export const soireeHot: string[] = [
  "Est-ce que coucher avec quelqu'un le premier soir dit quelque chose sur la personne ?",
  "Est-ce que l'attirance physique est aussi importante que la compatibilité émotionnelle ?",
  "Est-ce que les hommes et les femmes peuvent avoir les mêmes standards de liberté sexuelle ?",
  "Est-ce que quelqu'un du groupe a déjà eu une attirance pour une personne dans cette pièce ?",
  "Est-ce que le sexe sans sentiment peut être aussi satisfaisant que le sexe amoureux ?",
  "Est-ce que l'âge a une importance dans une relation amoureuse ?",
  "Est-ce que la jalousie peut être saine dans un couple ?",
  "Est-ce qu'on devrait parler de son passé amoureux à son/sa partenaire ?",
  "Est-ce que les relations ouvertes peuvent vraiment fonctionner ?",
  "Est-ce que l'apparence physique influence trop nos choix amoureux ?",
  "Est-ce que les applis de rencontre ont tué la romance ?",
  "Est-ce qu'on peut vraiment être ami avec quelqu'un qu'on a trouvé attirant ?",
  "Est-ce que le nombre de partenaires passés peut influencer une relation future ?",
  "Est-ce qu'on devrait parler de ses fantasmes à son/sa partenaire dès le début ?",
  "Est-ce que l'amour platonique peut être plus fort que l'amour romantique ?",
  "Est-ce que la compatibilité sexuelle est indispensable dans un couple ?",
  "Est-ce que quelqu'un du groupe a déjà fait quelque chose qu'il/elle regrette lors d'une soirée ?",
  "Est-ce qu'on devrait être totalement honnête sur son passé avec un nouveau partenaire ?",
  "Est-ce qu'une nuit parfaite peut changer une relation amicale pour toujours ?",
  "Est-ce que l'attirance physique peut complètement disparaître dans un couple et revenir ?",
  "Est-ce qu'on devrait tester sa compatibilité sexuelle avant de s'engager sérieusement ?",
  "Est-ce que quelqu'un dans ce groupe a déjà eu des sentiments pour quelqu'un dont il/elle ne devrait pas ?",
  "Est-ce qu'une relation purement physique peut rester sans sentiment pour toujours ?",
  "Est-ce que les hommes et les femmes vivent les ruptures différemment ?",
  "Est-ce qu'on devrait parler de ses expériences passées avec ses partenaires ou garder ça pour soi ?",
  "Est-ce que la passion dans un couple peut durer plus de 10 ans ?",
  "Est-ce que quelqu'un dans ce groupe a déjà fait quelque chose qu'il/elle n'assumera jamais ?",
  "Est-ce que l'amour peut naître d'une relation purement physique au départ ?",
  "Est-ce que la compatibilité intellectuelle est plus importante que la compatibilité physique ?",
  "Est-ce qu'une personne peut changer radicalement pour son/sa partenaire sans se perdre ?",
  "Est-ce que quelqu'un dans ce groupe a déjà eu une attirance pour quelqu'un en couple ce soir ?",
  "Est-ce qu'une relation peut rester saine sans intimité physique ?",
  "Est-ce que le regard des autres influence trop nos choix amoureux ?",
  "Est-ce qu'on peut tomber amoureux de quelqu'un qu'on n'a jamais rencontré en vrai ?",
  "Est-ce que la routine tue systématiquement le désir dans un couple ?",
  "Est-ce qu'une attirance physique forte peut faire ignorer tous les red flags ?",
  "Est-ce que les règles d'une relation ouverte peuvent vraiment être respectées sans jalousie ?",
  "Est-ce qu'une relation peut survivre quand l'un désire beaucoup plus que l'autre ?",
  "Est-ce qu'une soirée alcoolisée révèle la vraie personnalité des gens ou une version déformée ?",
];
